import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

import { slideCounter } from '../utils/slide-counter';

import 'swiper/css';

const EXPAND_DURATION = 400;

export function reviews() {
  document.querySelectorAll('.wp-block-reviews').forEach((block) => {
    const slider = block.querySelector('.swiper');
    if (!slider) {
      return;
    }

    // autoHeight fits the slider to the active slide, so a short quote leaves no
    // empty card below it. Arrow keys are left to the page rather than captured
    // by the carousel
    const swiper = new Swiper(slider, {
      direction: 'horizontal',
      speed: 500,
      spaceBetween: 30,
      autoHeight: true,
      loop: slider.querySelectorAll('.swiper-slide').length > 1,
      navigation: {
        nextEl: block.querySelector('.swiper-button-next'),
        prevEl: block.querySelector('.swiper-button-prev'),
      },
      on: {
        slideChange: slideCounter(block),
      },
      modules: [Navigation],
    });

    slider.querySelectorAll('.swiper-slide').forEach((slide) => quoteToggle(slide, swiper));
  });
}

/**
 * Wire up a quote's "read more" toggle: it only appears for quotes the line
 * clamp actually cuts off, and then also reveals the reviewer's name. Expanding
 * animates the review and the slider it sits in over the same duration so they
 * grow as one.
 */
function quoteToggle(slide, swiper) {
  const content = slide.querySelector('.review-content');
  const quote = slide.querySelector('.review-quote');
  const name = slide.querySelector('.review-name');
  const toggle = slide.querySelector('.review-quote-toggle');
  if (!content || !quote || !name || !toggle) {
    return;
  }

  let expanded = false;

  // Only measurable while collapsed; expanded the toggle has to stay either way
  const syncVisibility = () => {
    if (!expanded) {
      const clamped = quote.scrollHeight > quote.clientHeight;

      toggle.classList.toggle('hidden', !clamped);
      name.classList.toggle('hidden', clamped);
    }
  };

  // A narrower column wraps the quote over more lines, so the toggle is
  // re-evaluated on width alone — height changes are the expansion itself
  let width = quote.offsetWidth;

  new ResizeObserver(() => {
    if (quote.offsetWidth !== width) {
      width = quote.offsetWidth;
      syncVisibility();
    }
  }).observe(quote);

  syncVisibility();

  let animation;

  toggle.addEventListener('click', () => {
    const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : EXPAND_DURATION;

    // Read where the review is now, then drop any animation still running so
    // the height it settles on is the real one and not a frame of that animation
    const from = content.getBoundingClientRect().height;

    animation?.cancel();

    expanded = !expanded;
    quote.classList.toggle('line-clamp-4', !expanded);
    name.classList.toggle('hidden', !expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.querySelector('.show-more-text').classList.toggle('hidden', expanded);
    toggle.querySelector('.show-less-text').classList.toggle('hidden', !expanded);

    const to = content.getBoundingClientRect().height;

    animation = content.animate({ height: [`${from}px`, `${to}px`] }, { duration, easing: 'ease' });

    // The slider pins its height to the active slide, so it has to be resized
    // along with the review. Leaving that to Swiper's own transition makes it
    // ease towards a height the animation has already moved past, so it is
    // driven frame by frame instead, with the transition switched off. A
    // superseded run stops on its own: cancelling leaves its animation idle
    const current = animation;

    const follow = () => {
      swiper.updateAutoHeight(0);

      if (current.playState === 'running') {
        requestAnimationFrame(follow);
      }
    };

    follow();
  });
}
